import { Box } from "@mui/material";
import React from "react";
import { DotLegalPrettyScrollbar } from "@dotlegal/dotlegal-ui-components";
import { useDetailsWrapperStyles } from "./DetailsWrapper.styles";
import { useTranslation } from "../../localization/useTranslation";
import { getNotificationHeader, NotificationType } from "../Notification.types";

export interface DetailsWrapperProps {
    notificationType: NotificationType;
    description: string;
    isProcessingActivityValidation: boolean;
    date: Date;
    children: React.ReactNode;
}

const DetailsWrapper = React.forwardRef<HTMLDivElement, DetailsWrapperProps>(function DetailsWrapper(
    { notificationType, description, isProcessingActivityValidation, date, children },
    ref
) {
    const styles = useDetailsWrapperStyles();
    const { translateString, translateDate } = useTranslation();

    const getFullNotificationHeader = () => {
        if (isProcessingActivityValidation) {
            return `${translateString("taskNotifications")}: ${description}`;
        }

        switch (notificationType) {
            case NotificationType.LegalUpdates:
            case NotificationType.Release:
                return description;
            case NotificationType.ProcessingActivityCommentType:
            case NotificationType.TaskComment:
                return translateString("notificationNewCommentFullNotificationHeader");
            default:
                return `${getNotificationHeader(notificationType, translateString)}: ${description}`;
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <DotLegalPrettyScrollbar sx={styles.scrollbar} ref={ref}>
                <Box sx={styles.container}>
                    <Box sx={styles.header}>
                        <Box sx={styles.title}>{getFullNotificationHeader()}</Box>
                        <Box sx={styles.date}>{translateDate(date)}</Box>
                    </Box>
                    <Box sx={styles.content}>{children}</Box>
                </Box>
            </DotLegalPrettyScrollbar>
        </Box>
    );
});

export default DetailsWrapper;
